import { useState } from 'react';
import { authenticatedFetch } from '@/services/auth/authenticatedFetch.js';

const useGetOnboardingDocument = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);

    const getDocument = async (candidateUuid, documentType) => {
        setLoading(true);
        setError(null);
        let popup;

        try {
            popup = window.open('', '_blank');
            const response = await authenticatedFetch(
                `${window.ENV.BACKEND_URL}/onboarding/api/secured/admin/document/${candidateUuid}/${documentType}`,
                {
                    method: 'GET',
                },
            );

            if (!response.ok) {
                let errorMessage = `HTTP error! Status: ${response.status}`;
                const contentType = response.headers.get('content-type') || '';

                if (contentType.includes('application/json')) {
                    const errorBody = await response.json();
                    errorMessage = errorBody?.detail || errorBody?.message || errorMessage;
                } else {
                    const errorBodyText = await response.text();
                    if (errorBodyText) {
                        errorMessage = errorBodyText;
                    }
                }

                throw new Error(errorMessage);
            }

            const blob = await response.blob();
            setData(blob);
            const url = URL.createObjectURL(blob);
            if (popup) {
                popup.location.href = url;
            }

            setTimeout(() => {
                URL.revokeObjectURL(url);
            }, 10000);
        } catch (err) {
            if (popup) {
                popup.close();
            }

            setError(err);
        } finally {
            setLoading(false);
        }
    };

    return { getDocument, data, loading, error, refetch: getDocument };
};

export default useGetOnboardingDocument;
